var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.545,
    height: 18.624,
    viewBox: "0 0 18.545 18.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "border_color_FILL0_wght400_GRAD0_opsz48",
    d: "M8.1,25.9V21.682l9.922-9.922,4.216,4.216L12.316,25.9ZM10,24h1.427l8.084-8.084-1.427-1.427L10,22.57Zm13.631-9.415-4.216-4.216L22.08,7.7a1.076,1.076,0,0,1,.793-.428,1.213,1.213,0,0,1,.888.428l2.473,2.473a1.227,1.227,0,0,1,.412.872,1.331,1.331,0,0,1-.349.872ZM10,24Z",
    transform: "translate(-8.1 -7.274)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit_icon_white.8d4501a9e23e25a804036c14c913139c.svg";
export { ForwardRef as ReactComponent };